import React, { useEffect, useState } from 'react';

export default function InstallApp() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }
    setDeferredPrompt(null);
  };

  // Don't show button if app is already installed or not supported
  if (!deferredPrompt) return null;

  return (
    <button 
      onClick={handleInstallClick} 
      className="btn-ap animated-search-btn"
      style={{ 
        position: 'fixed', 
        bottom: '20px', 
        right: '20px', 
        zIndex: 9999,
        padding: '0.8rem 1.5rem',
        borderRadius: '30px',
        boxShadow: '0 10px 25px rgba(67, 56, 202, 0.4)'
      }}
    >
      📱 Install App
    </button>
  );
}